import React from 'react';
import TenantActiveUsers from './TenantActiveUsers';
import TenantUsersList from './TenantUsersList';


function Overview({ tenant }) {
  return <>
    <TenantActiveUsers tenant={tenant}/>
    <TenantUsersList />
  </>;
}

export default Overview;
